import { useNavigate } from "react-router-dom";
import { SecondaryButton } from "@coffee/ui/components/buttons";
import { LocalStorageKeys, useLocalStorage } from "@coffee/ui/hooks";
import styled from "@emotion/styled";
import { ChatBubbleOvalLeftIcon } from "@heroicons/react/24/solid";
import { Icon } from "@unlikelyai-magic/ui/icons";
import { Spacing } from "@unlikelyai-magic/ui/layouts";
import { Heading, Paragraph } from "@unlikelyai-magic/ui/typography";
import { MessageInput } from "./MessageInput";

const EmptyStateContainer = styled(Spacing)`
  flex: 1;
  width: 100%;
`;

const EmptyChatInput = styled(MessageInput)`
  max-width: 40rem;
  width: 100%;
  font-size: 1rem;
  margin: 0 auto;
`;

type EmptyChatProps = {
  onSubmitUserMessage: (text: string) => void;
};

export const EmptyChat = ({ onSubmitUserMessage }: EmptyChatProps) => {
  const navigate = useNavigate();

  const [answerIds, _] = useLocalStorage<string[]>(
    LocalStorageKeys.ANSWER_IDS,
    []
  );

  return (
    <EmptyStateContainer justify="center" items="center" gap="xl">
      <Heading level="h3">How can I help?</Heading>
      <Paragraph>Ask me about the Remote Work Eligibility Policy.</Paragraph>
      <EmptyChatInput
        placeholder={`Ask me a question...`}
        onSubmit={onSubmitUserMessage}
      />
      <SecondaryButton
        disabled={answerIds.length === 0}
        onClick={() => navigate("/recents")}
      >
        <Icon icon={ChatBubbleOvalLeftIcon} />
        {answerIds.length} previous questions
      </SecondaryButton>
    </EmptyStateContainer>
  );
};
